import { z } from 'zod'
import ApiService from '../api.service'

import { zod } from '@acme/core'
import { EspelhoPonto } from './espelho'

export interface CreateCalculo {
    funcionarioIds?: number[]
    competencia: string
    empresaId: number
    justificativa?: string
}

type Query =
    | { competencia: string; empresaId: number }
    | { id: number }
    | { funcionarioId: number; competencia: string }

const historicoCalculoSchema = zod.HistoricoCalculoSchema.extend({
    logs: z.array(zod.HistoricoCalculoLogsSchema),
})

export type LogCalculos = z.infer<typeof zod.LogCalculosSchema>

export type FuncionarioComEspelhoAceito = {
    funcionarioId: number
    nome: string
    matricula: number
}

export type HistoricoCalculo = z.infer<typeof historicoCalculoSchema>

/** Corpo do 409 quando há espelhos aceitos e o pedido não diz o que fazer com eles. */
export type ConflitoEspelhosAceitos = {
    statusCode: 409
    message: string
    funcionariosComEspelhoAceito: FuncionarioComEspelhoAceito[]
    totalCandidatos: number
}

export type CalculoEmpresaInput = {
    empresaId: number | number[]
    competencia: string
    centroCustoId?: number
    locaisIds?: number[]
    baixarPdf?: boolean
    baixarZip?: boolean
    funcionarioIds?: number[]
    /** Recalcula também quem já aceitou o espelho, registrando o motivo. */
    justificativa?: string
    /** Pula quem já aceitou o espelho. */
    apenasSemAceite?: boolean
}

const historico = new ApiService<CalculoEmpresaInput, HistoricoCalculo>(
    'calculo-ponto',
)

const service = new ApiService<CreateCalculo, EspelhoPonto, Query>('calculo')

export const calculo = Object.assign(service, {
    historico,
})
